<template>
    <el-dialog v-model="dialogShow" title="下载资源包" width="600px" align-center="true" :before-close="handleClose"
        destroy-on-close>

        <div class="inrect vh-flex" v-loading="showLoading" element-loading-text="正在导入中..">
            <div class="vc-flex vhes">
                <SvgIcon svgname="ic_readbook" :size="64"></SvgIcon>
                <div class="mgl10">
                    <div class="lbname">{{ resInfo.name }}</div>
                    <div class="lbdesc">暂无描述</div>
                </div>
            </div>
            <div class="vh-full">

            </div>
            <div @click="startDownload" class="bntdown focus-s">
                <svg-icon svgname="ic_listadd" :size="14" fill="white"></svg-icon>
                <span class="mgl10">添加到我的课程库</span>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import httpClient from '@/commom/http/httpClient'
import SvgIcon from '@/components/SvgIcon.vue';
export default {
    name: 'DownloadResourceDialog',
    components: {
        SvgIcon
    },
    props: {
        show: Boolean,
        resInfo: Object
    },
    watch: {
        show: function (nval, old) {
            this.dialogShow = nval

        },

    },
    data() {
        return {
            dialogShow: this.showDialog,
            showLoading:false
        }
    },
    methods: {
        handleClose: function () {
            this.selectButton(false)
        },
        ///选择按钮
        selectButton: function (result) {
            this.$emit("selectButton", result)
        },
        //开始下载
        startDownload: function () {
            
            var req = {
                resId:this.resInfo.id
            }
            this.showLoading = true
            var that = this
            httpClient.invoke("ResourceInfoAPI.DownloadResource",req,function(res){
                that.showLoading = false
                if(res.error){
                    that.$message.error(res.error)
                    return
                }
                that.$message.success("导入完成")
                that.selectButton(true)
            })
        }


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vhes {
    border-bottom: 1px solid var(--ek-split-lineColor);
    padding-bottom: 10px;
}

.inrect {
    height: 500px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 15px;
}

.lbname {
    font-size: 16px;
    color: var(--ek-text-color1);
}

.lbdesc {
    margin-top: 5px;
    font-size: 14px;
    color: var(--ek-text-color2);
}

.bntdown {
    background: var(--ek-color-primary);
    color: white;
    height: 38px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>